const apiEndPoint = {
    FETCH_PROFILE: `/api/v1/users/fetch_user`,
    FETCH_SURVEY_QUESTIONS: `/api/v1/survey_questions`,
    FETCH_ENTREPRENEURIAL_SURVEY_QUESTIONS: `/api/v1/entrepreneurial/get_current_question`,
    FETCH_ENTREPRENEURIAL_REPORT: "/api/v1/entrepreneurial/calculate_entrepreneurial_report",
    FETCH_ADMIN_ENTREPRENEURIAL_REPORT: "/api/v1/entrepreneur_admin/assessment_report/calculate_entrepreneurial_report",
    FETCH_ENTREPRENEURIAL_USER_BY_EMAIL: "/api/v1/entrepreneurial/get_assessment_user_details",
    SAVE_ENTREPRENEURIAL_QUESTIONS_ANSWER: "/api/v1/entrepreneurial/save_answer",
    FETCH_PROLIFIC_FEEDBACK_QUESTIONS: '/api/v1/prolific_questions',
    FETCH_GENERIC_FEEDBACK_QUESTIONS: '/api/v1/generic_questions',
    GENERIC_FEEDBACK_QUESTIONS_RESPONSES: '/api/v1/generic_responses',
    SUBMIT_SURVEY_QUESTIONS: '/api/v1/survey_responses',
    FETCH_GENERIC_DEMOGRAPHIC_QUESTIONS: '/api/v1/survey_questions/demographic_questions',
    SUBMIT_GENERIC_DEMOGRAPHICS_QUESTIONS: '/api/v1/survey_responses',
    FETCH_GAME_COMPLETED_PERCENTAGES: `/api/v1/games/games_percentage`,
    FETCH_ORG_ADMIN_DASHBOARD_COUNT: '/api/v1/dashboard',
    FETCH_ORG_ADMIN_DASHBOARD_USERS_DATA: '/users',
    FETCH_USER_GAMES_SURVEY: '/api/v1/user_data',
    CURD_ORGANISATION_SERVICE: '/api/v1/organisations',
    UPDATE_ORGANISATION_SERVICE: (id) => `/api/v1/organisations/${id}`,
    DELETE_ORGANISATION_SERVICE: (id) => `/api/v1/organisations/${id}`,
    FETCH_STUDENT_QUERY_SERVICE: 'api/v1/user_queries',
    UPDATE_STUDENT_QUERY_SERVICE: (id) => `/api/v1/update_query_status/${id}`,
    FETCH_STUDENT_QUERY_MESSAGE: (id) => `/api/v1/find_query_message/${id}`,
    UPLOAD_USER_ATTACHMENTS: '/api/v1/upload_user_attachments',
    SHARE_ATTACHMENTS_LINK: '/api/v1/share_assessment_link',
    GENERATE_OTP: "/api/v1/generate_otp",
    VALIDATE_OTP: '/api/v1/validate_otp',
    IS_NEW_USER: '/api/v1/is_new_user',
    GENERATE_LOGIN_OTP: '/api/v1/generate_login_otp',
    VALIDATE_LOGIN_OTP: '/api/v1/validate_login_otp',
    SUBMIT_INTRO_CONSENT: '/api/v1/entrepreneurial/submit_assessment_consent',
    CREDIT_CARD_PAYMENT: '/api/v1/entrepreneurial/credit_card_payment',
    REDEEM_ACCESS_CODE: '/api/v1/entrepreneurial/redeem_access_code',
    GET_PLANS_DETAILS: '/api/v1/get_plans_details',
    VERIFY_ACCESS_CODE: '/api/v1/access_codes/verify_access_code',
    GENERATE_ACCESS_CODE: '/api/v1/access_codes/generate_access_code',
    MASTER_ACCESS_CODES: '/api/v1/master_access_codes',
    MASTER_ACCESS_CODES_BULK: '/api/v1/master_access_codes/bulk_create',
}

export default apiEndPoint;